module.exports = __webpack_public_path__ + "img/moishop_portfolio_6_mob.e8d1adf8.png";